import { Component, OnInit } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { UpdateProfileGQL } from '@app/graphql/generated';
import { AccountSettingsService } from '@app/account/account-settings/account-settings.service';

@Component({
  selector: 'app-user-change-password',
  templateUrl: './user-change-password.component.html',
  styleUrls: ['./user-change-password.component.scss']
})
export class UserChangePasswordComponent implements OnInit {
  model = { password: '' };
  fields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'row mt-5',
      fieldGroup: [
        {
          key: 'password',
          className: 'col-12',
          validators: {
            fieldMatch: {
              expression: control => {
                const value = control.value;

                const isValid =
                  value.confirmPassword === value.password ||
                  // avoid displaying the message error when values are empty
                  !value.confirmPassword ||
                  !value.password;

                return isValid;
              },
              message: 'Passwords must match',
              errorPath: 'confirmPassword'
            }
          },
          fieldGroup: [
            {
              key: 'password',
              type: 'input',
              name: 'Password',
              templateOptions: {
                type: 'password',
                placeholder: 'Enter new password',
                required: true,
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&,.]).{8,100}$/
              },
              validation: {
                messages: {
                  pattern: (error, field: FormlyFieldConfig) =>
                    `Password must be at least 8 characters and contain one of each: upper case, lower case, number and symbol`
                }
              }
            },
            {
              key: 'confirmPassword',
              type: 'input',
              name: 'Confirm password',
              templateOptions: {
                placeholder: 'Confirm new password',
                type: 'password',
                required: true
              }
            }
          ]
        }
      ]
    }
  ];

  form = new FormGroup({});

  constructor(
    private updateProfileGQL: UpdateProfileGQL
    , private accountSettingsService: AccountSettingsService) {
  }

  ngOnInit() {

  }

  submit() {
    console.log('submit');
    this.accountSettingsService.updatePassword$.next(this.form.value.password.password);
  }


}
